import {FarmProductTypeRequest, FarmProductTypeStructRequest, FarmProductTypeInteractor} from "../../Coordinator/FarmProductType/FarmProductTypeInteractor";

export class FarmProductTypeViewModel {
    private interactor: FarmProductTypeInteractor;

    constructor() {
        this.interactor = new FarmProductTypeInteractor();
    }

    public fetchSave(obj: any): PromiseLike<any> {
        var request = new FarmProductTypeRequest(
            obj["sgeptpprodagropecuario"] ? parseInt(obj["sgeptpprodagropecuario"]) : 0,
            obj["nome"] ? obj["nome"] : "",
            obj["sgepclassificacaotpprodagropecuario"] ? parseInt(obj["sgepclassificacaotpprodagropecuario"]) : 0
        )
        
        return new Promise((res, rej) => {  
            this.interactor.fetchSave(request).then((result) => {
                return res()
            }, e => {
                return rej(e)
            });
        })
    }

    public fetchDataOne(obj: any): PromiseLike<any> {
        var request = new FarmProductTypeStructRequest(
            obj["sgeptpprodagropecuario"] ? parseInt(obj["sgeptpprodagropecuario"]) : 0
        )
        
        return new Promise((res, rej) => {
            this.interactor.fetchDataOne(request).then((result) => {
                return res(result)
            }, e => {
                return rej(e)
            });
        })
    }
    public fetchSelectClassification(): PromiseLike<any> {
        return new Promise((res, rej) => {
            this.interactor.fetchSelectClassification().then((result) => {
                return res(result)
            }, e => {
                return rej(e)
            });
        })
    } 
}